module.exports = __webpack_public_path__ + "static/shotlists_setups-64d5c20a115aae7e3afe8936bbc6547c.png";